import { Grid } from "@mui/material";
import { PrimaryButton } from "../../theme/index";
import "../../sass/styles.scss";
import { UseScreen } from "../../hooks/UseScreen.hook";
import { useDispatch } from "react-redux";
import { modalDeleteAction } from "../../redux/reducers/Modal";
import { useNavigate } from "react-router-dom";

const SignOut = () => {
  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const signOutFunction = () => {
    dispatch(modalDeleteAction()).then((response) => {
      localStorage.removeItem("htuser");
      localStorage.removeItem("ht-fullname");
      localStorage.removeItem("ht-role");
      navigate("/");
    });
  };

  return (
    <>
      <Grid item xs={10}>
        {screenWidth > 500 ? (
          <h5 style={{ margin: "0", marginBottom: "2rem" }}>Cerrar sesión</h5>
        ) : (
          <h6 style={{ margin: "0", marginBottom: "2rem" }}>Cerrar sesión</h6>
        )}
      </Grid>
      <Grid item xs={12} textAlign="center">
        {screenWidth > 500 ? (
          <h3>Esta seguro que desea cerrar sesión?</h3>
        ) : (
          <h6>Esta seguro que desea cerrar sesión?</h6>
        )}
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }} textAlign="center" className="pr-2">
        <PrimaryButton
          onClick={() => signOutFunction()}
          sx={{ width: "50%", boxShadow: 5 }}
        >
          Cerrar
        </PrimaryButton>
      </Grid>
    </>
  );
};

export default SignOut;
